/**
 * Labstep
 *
 * @module components/SignatureRequest/Action/ViewList
 * @desc A modal to show a list of signature requests
 */

import { SignatureRequestListContainer as SignatureRequestList } from 'labstep-web/components/SignatureRequest/List';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { ISignatureRequestActionViewListProps } from './types';

export const SignatureRequestActionViewList: React.FC<
  ISignatureRequestActionViewListProps
> = ({ experimentWorkflow }) => (
  <ModalDefault
    size="large"
    header="Pending Requests"
    content={() => (
      <SignatureRequestList experimentWorkflow={experimentWorkflow} />
    )}
    viewComponent={({ toggleModal }) => (
      <ActionComponent
        type="text"
        text="View pending requests"
        onClick={toggleModal}
      />
    )}
  />
);
